import type { InventoryItem } from '@app/types/shop-bff/types';
import { ColorFieldConfigurator } from '../ProductConfigurator/FieldConfigurators/ColorFieldConfigurator';
import type { ColorOption } from '../ProductConfigurator/FieldConfigurators/types';
import {
  ConfiguratorOption,
  getColorOptionConfig,
  getTranslatedString,
} from './utils';

export type PTRColorFieldConfiguratorProps = {
  locale: string;
  option: ConfiguratorOption;
  currentValue: string;
  filterValues: Array<{
    value: ConfiguratorOption['values'][number];
    inventoryItem: InventoryItem;
  }>;
  errors: Record<string, string>;
};

export const PTRColorFieldConfigurator: React.FC<
  PTRColorFieldConfiguratorProps
> = ({ locale, option, currentValue, filterValues }) => {
  const label = getTranslatedString(option.publicName, option.key, locale);

  const colorOptions = filterValues
    .map(({ value }) => getColorOptionConfig(value, locale))
    .filter((opt): opt is ColorOption => opt !== null);

  return (
    <ColorFieldConfigurator
      label={label}
      attributeName={option.key}
      currentValue={currentValue}
      options={colorOptions}
    />
  );
};
